import styles from './LeadersSection.module.css';
import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import { LeadersWidget } from '@features/landing/grandprix/ui/components/Leaders';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { ComponentProps } from 'react';

const SIZE_BY_DEVICE: Record<
  ReturnType<typeof useMediaQuery>,
  ComponentProps<typeof LeadersWidget>['size']
> = {
  mobile: 'small',
  tablet: 'medium',
  desktop: 'large',
};

export function LeadersSection() {
  const device = useMediaQuery();

  return (
    <LandingSection className={styles.root}>
      <div className={styles.anchor} id="grandprix-leaders" />
      <LeadersWidget size={SIZE_BY_DEVICE[device]} />
    </LandingSection>
  );
}
